import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { PageBanner } from '../Banners/PageBanner'
import { useBlogPostForm } from '../../hooks/useBlogPostForm'
import BlogPostHeader from './BlogPostHeader'
import ImageUploader from './ImageUploader'
import CategoriesManager from './CategoriesManager'
import FormFields from './FormFields'
import FormActions from './FormActions'

const BlogPostForm: React.FC = () => {
  const {
    formData,
    setFormData,
    loading,
    fetchLoading,
    error,
    success,
    isEditing,
    handleChange,
    generateSlug,
    updateImage,
    handleSubmit,
    setError,
    setSuccess
  } = useBlogPostForm()

  const handleCategoriesChange = (newCategories: string[]) => {
    setFormData({ ...formData, categories: newCategories })
  }

  if (fetchLoading && isEditing) {
    return (
      <div className='container mt-5'>
        <div className='text-center'>
          <div className='spinner-border text-primary' role='status'>
            <span className='visually-hidden'>Ładowanie...</span>
          </div>
          <p className='mt-3'>Wczytywanie danych artykułu...</p>
        </div>
      </div>
    )
  }

  return (
    <>
      <PageBanner
        title={isEditing ? 'Edycja artykułu' : 'Dodawanie nowego artykułu'}
        description={isEditing ? 'Edytuj istniejący artykuł' : 'Dodaj nowy artykuł'}
      />

      <div className='container my-5'>
        <div className='row'>
          <div className='col-12'>
            <BlogPostHeader isEditing={isEditing} />

            {error && (
              <div className='alert alert-danger' role='alert'>
                {error}
              </div>
            )}

            {success && (
              <div className='alert alert-success' role='alert'>
                {success}
              </div>
            )}

            <div className='card border-0 shadow-sm'>
              <div className='card-body p-4'>
                <form onSubmit={handleSubmit} className='mt-2'>
                  <div className='row'>
                    <div className='col-12 col-lg-8'>
                      <FormFields
                        formData={formData}
                        handleChange={handleChange}
                        generateSlug={generateSlug}
                      />
                    </div>

                    <div className='col-12 col-lg-4'>
                      <div className='sticky-top' style={{ top: '2rem' }}>
                        <ImageUploader
                          currentImage={formData.image}
                          onImageUploaded={updateImage}
                          onError={setError}
                          onSuccess={setSuccess}
                        />

                        <CategoriesManager
                          categories={formData.categories}
                          onCategoriesChange={handleCategoriesChange}
                        />
                      </div>
                    </div>
                  </div>

                  <FormActions isEditing={isEditing} loading={loading} />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BlogPostForm
